import React from 'react';
import cn from 'classnames';

import GeneralRate from '../GeneralRate';
import { isMobileOrTablet } from 'client/hooks/responsive';
import { apiRatingMultiply } from 'utils/apiRatingMultiply';

import css from './HotelRateCard.module.scss';

type Props = {
  mako: number;
  booking?: number | null;
  adminBooking?: number | null;
  url?: string | null;
  name?: string;
};

const HotelRankCard = (props: Props) => {
  const { mako, booking, url, name, adminBooking } = props;
  const isMobile = isMobileOrTablet();

  return (
    <div className={cn(css.cardContainer, isMobile && css.mobile)}>
      <div className={css.greenLine} />
      <div className={css.rate}>
        {!!adminBooking || !!booking ? (
          <>
            <GeneralRate rate={mako} from="mako" />
            {!!adminBooking ? (
              <GeneralRate rate={adminBooking} from="booking" url={url} name={name} />
            ) : (
              <>
                {booking ? (
                  <GeneralRate
                    rate={booking > 0 ? apiRatingMultiply(booking) : 0}
                    from="booking"
                    url={url}
                    name={name}
                  />
                ) : null}
              </>
            )}
          </>
        ) : (
          <GeneralRate rate={mako} from="mako" className="onlyMako" />
        )}
      </div>
    </div>
  );
};

export default HotelRankCard;
